/* istanbul ignore file */
import { FormRow } from 'framework/ui/layout';
import { useEffect } from 'react';
import { CurrencyInput, useFormContext } from 'framework/form';
import { CurrencyDropdown } from 'domain/shared/core/input';
import offerFormValidationSchema from './offerFormValidationSchema';
import { SubmitButton } from 'framework/ui/ui-builder';
import { Button } from 'framework/ui/mui-builder';
import { CURRENCY_TYPES } from 'domain/shared/core/constants';
import { Box } from '@mui/material';

interface OfferFormProps {
  handleCancelClick: () => void;
}

const OfferForm = ({ handleCancelClick }: OfferFormProps) => {
  const { submitForm, isSubmitEnabled, isLoadingArtifact, setValidationSchemaAction } = useFormContext();

  useEffect(() => {
    if (setValidationSchemaAction) {
      setValidationSchemaAction(offerFormValidationSchema);
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <>
      <FormRow>
        <CurrencyInput source="offerSum" label="Offer Sum" isRequired />
        <CurrencyDropdown source="compensationCurrency" options={CURRENCY_TYPES} label="Currency" />
      </FormRow>

      <Box display="flex" gap={1.25}>
        <SubmitButton
          key="submit-modal-btn"
          onClick={submitForm}
          isLoading={!isSubmitEnabled}
          disabled={isLoadingArtifact}
        />
        <Button
          variant="outlined"
          key="cancel-modal-btn"
          onClick={handleCancelClick}
          disabled={!isSubmitEnabled || isLoadingArtifact}
        >
          Cancel
        </Button>
      </Box>
    </>
  );
};

export default OfferForm;
